@let isExternal = link?.external;
@let isHttp = isHttpUrlLink(link?.url);
@let isChat = link?.url === '<<chat>>';

@if (isScriptLink) {
  <a
    href="#"
    (click)="clickScriptLink($event, link?.url)"
    [class]="customClass"
    [attr.role]="role"
    [attr.rel]="rel"
    [routerLinkActive]="activeClass || ''"
    [attr.aria-label]="ariaLabel"
    [attr.tabindex]="tabIndex"
  >
    <ng-container *ngTemplateOutlet="content" />
  </a>
}

@if (indexFollow && !isScriptLink) {
  <!-- Display link as a default link -->
  @if (!isButton && !icon) {
    @if (!isHttp) {
      <a
        [class]="customClass"
        [attr.role]="role"
        [attr.rel]="rel"
        [routerLink]="splitedUrl"
        [queryParams]="queryParams"
        [fragment]="fragment"
        [routerLinkActive]="activeClass || ''"
        [attr.aria-label]="ariaLabel"
        (click)="onClick()"
        [attr.tabindex]="tabIndex"
        (keydown.enter)="onClick()"
        [target]="isExternal ? '_blank' : '_self'">
        <ng-container *ngTemplateOutlet="content" />
      </a>
    }
    @if (isHttp) {
      <a
        [class]="customClass"
        [href]="link?.url"
        [attr.role]="role"
        [attr.rel]="rel"
        [attr.tabindex]="tabIndex"
        (click)="onClick()"
        (keydown.enter)="onClick()"
        [attr.aria-label]="ariaLabel"
        [target]="isExternal ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="content" />
      </a>
    }
  }

  <!-- Display link as a default button -->
  @if (isButton) {
    @if (!isHttp) {
      <a
        class="{{customClass}} {{isDisabled ? 'is-disabled' : ''}} {{isChat ? 'idz_btn_fix' : ''}}"
        sd-button
        [attr.role]="role"
        [attr.rel]="rel"
        [theme]="theme"
        [attr.tabindex]="tabIndex"
        [brand]="brand"
        (click)="onClick($event)"
        (keydown.enter)="onClick($event)"
        [isSecondary]="isSecondary"
        [isSmall]="isSmall"
        [icon]="link.url === '<<chat>>' ? 'icon-chat' : icon"
        [iconPos]="iconPos"
        [isIcon]="isIcon"
        [routerLinkActive]="activeClass || ''"
        [routerLink]="isChat ? null : splitedUrl"
        [queryParams]="queryParams"
        [fragment]="fragment"
        [target]="isExternal ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="content" />
      </a>
    }

    @if (isHttp) {
      <a
        class="{{customClass}} {{isDisabled ? 'is-disabled' : ''}}"
        sd-button
        [attr.role]="role"
        [attr.rel]="rel"
        [brand]="brand"
        (click)="onClick()"
        [attr.tabindex]="tabIndex"
        (keydown.enter)="onClick()"
        [theme]="theme"
        [isSmall]="isSmall"
        [icon]="icon"
        [iconPos]="iconPos"
        [isIcon]="isIcon"
        [isSecondary]="isSecondary"
        [href]="link?.url"
        [target]="isExternal ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="content" />
      </a>
    }
  }

  <!-- Display link as a button icon -->
  @if (icon && !isButton) {
    @if (!isHttp) {
      <a
        sd-button-icon
        [brand]="brand"
        [class]="customClass"
        [attr.tabindex]="tabIndex"
        [attr.role]="role"
        [attr.rel]="rel"
        [buttonIconTitle]="buttonIconTitle"
        [titleHidden]="titleHidden"
        [iconPos]="iconPos"
        [isSmall]="isSmall"
        (click)="onClick()"
        (keydown.enter)="onClick()"
        [size]="size"
        [icon]="icon"
        [routerLinkActive]="activeClass || ''"
        [routerLink]="splitedUrl"
        [queryParams]="queryParams"
        [fragment]="fragment"
        [target]="isExternal ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="content" />
      </a>
    }

    @if (isHttp) {
      <a
        sd-button-icon
        [brand]="brand"
        [class]="customClass"
        [attr.role]="role"
        [attr.rel]="rel"
        [buttonIconTitle]="buttonIconTitle"
        [iconPos]="iconPos"
        [titleHidden]="titleHidden"
        [isSmall]="isSmall"
        [attr.tabindex]="tabIndex"
        (click)="onClick()"
        (keydown.enter)="onClick()"
        [icon]="icon"
        [size]="size"
        [href]="link?.url"
        [target]="isExternal ? '_blank' : '_self'"
      >
        <ng-container *ngTemplateOutlet="content" />
      </a>
    }
  }
}

@if (!indexFollow && !isScriptLink) {
  <!-- Display link as a default link -->
  @if (!isButton && !icon) {
    @if (!isHttp) {
      <button
        class="is-reset is-link {{customClass}}"
        [attr.role]="role"
        [attr.rel]="rel"
        [routerLink]="splitedUrl"
        [queryParams]="queryParams"
        [fragment]="fragment"
        [routerLinkActive]="activeClass || ''"
        [attr.aria-label]="ariaLabel"
        (click)="onClick()"
        [attr.tabindex]="tabIndex"
        (keydown.enter)="onClick()"
      >
        <ng-container *ngTemplateOutlet="content" />
      </button>
    }

    @if (isHttp) {
      <button
        class="is-reset is-link {{customClass}}"
        [attr.role]="role"
        [attr.rel]="rel"
        [attr.tabindex]="tabIndex"
        (click)="onClick()"
        (keydown.enter)="onClick()"
        [attr.aria-label]="ariaLabel"
      >
        <ng-container *ngTemplateOutlet="content" />
      </button>
    }
  }

  <!-- Display link as a default button -->
  @if (isButton) {
    @if (!isHttp) {
      <button
        class="{{customClass}} {{isDisabled ? 'is-disabled' : ''}} {{isChat ? 'idz_btn_fix' : ''}}"
        sd-button
        [brand]="brand"
        [attr.role]="role"
        [attr.rel]="rel"
        [theme]="theme"
        [attr.tabindex]="tabIndex"
        (click)="onClick($event)"
        (keydown.enter)="onClick($event)"
        [isSecondary]="isSecondary"
        [isSmall]="isSmall"
        [icon]="link.url === '<<chat>>' ? 'icon-chat' : icon"
        [iconPos]="iconPos"
        [isIcon]="isIcon"
        [routerLinkActive]="activeClass || ''"
        [routerLink]="isChat ? null : splitedUrl"
        [queryParams]="queryParams"
        [fragment]="fragment"
      >
        <ng-container *ngTemplateOutlet="content" />
      </button>
    }

    @if (isHttp) {
      <button
        class="{{customClass}} {{isDisabled ? 'is-disabled' : ''}}"
        sd-button
        [brand]="brand"
        [attr.role]="role"
        [attr.rel]="rel"
        (click)="onClick()"
        [attr.tabindex]="tabIndex"
        (keydown.enter)="onClick()"
        [theme]="theme"
        [isSmall]="isSmall"
        [icon]="icon"
        [iconPos]="iconPos"
        [isIcon]="isIcon"
        [isSecondary]="isSecondary"
      >
        <ng-container *ngTemplateOutlet="content" />
      </button>
    }
  }

  <!-- Display link as a button icon -->
  @if (icon && !isButton) {
    @if (!isHttp) {
      <button
        sd-button-icon
        [brand]="brand"
        [class]="customClass"
        [attr.tabindex]="tabIndex"
        [attr.role]="role"
        [attr.rel]="rel"
        [buttonIconTitle]="buttonIconTitle"
        [titleHidden]="titleHidden"
        [iconPos]="iconPos"
        [isSmall]="isSmall"
        (click)="onClick()"
        (keydown.enter)="onClick()"
        [size]="size"
        [icon]="icon"
        [routerLinkActive]="activeClass || ''"
        [routerLink]="splitedUrl"
        [queryParams]="queryParams"
        [fragment]="fragment"
      >
        <ng-container *ngTemplateOutlet="content" />
      </button>
    }

    @if (isHttp) {
      <button
        sd-button-icon
        [brand]="brand"
        [class]="customClass"
        [attr.role]="role"
        [attr.rel]="rel"
        [buttonIconTitle]="buttonIconTitle"
        [iconPos]="iconPos"
        [titleHidden]="titleHidden"
        [isSmall]="isSmall"
        [attr.tabindex]="tabIndex"
        (click)="onClick()"
        (keydown.enter)="onClick()"
        [icon]="icon"
        [size]="size"
      >
        <ng-container *ngTemplateOutlet="content" />
      </button>
    }
  }
}

<ng-template #content>
  <ng-content />
</ng-template>